<template>
  <div class="infoTable mb-3">
    <v-layout row wrap>
      <v-flex xs12>
        <v-icon small class="k-orange-linear-text mb-1">fas fa-receipt</v-icon>
        <span class="subheading font-weight-medium">Información financiera</span>
        <v-divider></v-divider>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex md3>
        <small>Cartera</small>
        <br />
        <p
          class="caption"
        >{{ portfolio(customer.portfolio_type_id).name || 'Sin información' }}</p>
      </v-flex>
      <v-flex md3>
        <small>{{accountTypeName}}</small>
        <br />
        <p
          class="caption w-80"
        >{{ account(customer.account_type_id).name || 'Sin información' }}</p>
      </v-flex>
      <v-flex md3>
        <small>Tramo</small>
        <br />
        <p class="caption">{{ tranche(customer.tranche_id).name || 'Sin información' }}</p>
      </v-flex>
      <v-flex md3>
        <small>Antigüedad</small>
        <br />
        <p class="caption">{{ customer.seniority || 'Sin información' }}</p>
      </v-flex>
    </v-layout>
    <v-layout row wrap mt-2>
      <v-flex md3>
        <small>Fecha de Vencimiento</small>
        <br />
        <p
          class="caption"
        >{{ customer.due_date ? formatDate(customer.due_date, 'YYYY-MM-DD', 'DD/MM/YYYY') : 'Sin especificar'}}</p>
      </v-flex>
      <v-flex md3>
        <small>Fecha de Compromiso</small>
        <br />
        <p
          class="caption"
        >{{ customer.payment_promise ? formatDate(customer.payment_promise, 'YYYY-MM-DD', 'DD/MM/YYYY') : 'Sin especificar'}}</p>
      </v-flex>
      <v-flex md3>
        <small>Días de Mora</small>
        <br />
        <p class="caption">{{ customer.delinquency === 0 ? 0 : (customer.delinquency || 'Sin especificar') }}</p>
      </v-flex>
      <v-flex md3>
        <small>Agencia</small>
        <br />
        <p class="caption">{{ agency(customer.agency_id).name || 'Sin información' }}</p>
      </v-flex>
      <v-flex md3>
        <small>Segmento de balance</small>
        <br />
        <p class="caption">{{ customer.segment_balance || 'Sin información' }}</p>
      </v-flex>
      <template v-if="customer.bill_id">
        <v-flex md3>
          <small>{{ dueName }}</small>
          <br />
          <p class="caption">{{ bill(customer.bill_id).descrip || 'Sin información' }}</p>
        </v-flex>
        <v-flex md3 v-if="$auth.user().company_id === 1900910">
          <small>N° de poliza</small>
          <br />
          <p class="caption">{{ bill(customer.bill_id).reference || 'Sin información' }}</p>
        </v-flex>
        <v-flex md3>
          <small>Fecha</small>
          <br />
          <p
            class="caption"
          >{{ bill(customer.bill_id).due_date ? formatDate(bill(customer.bill_id).due_date, 'YYYY-MM-DD', 'DD/MM/YYYY') : 'Sin información' }}</p>
        </v-flex>
        <v-flex md3>
          <small>{{ invoicedName }}</small>
          <br />
          <p
            class="caption"
          >{{ bill(customer.bill_id).invoiced_balance ? formatNumber((bill(customer.bill_id).invoiced_balance)) : 'Sin información' }}</p>
        </v-flex>
        <v-flex md3>
          <small>{{ dueBalance }}</small>
          <br />
          <p
            class="caption"
          >{{ bill(customer.bill_id).due_balance ? formatNumber(bill(customer.bill_id).due_balance) : 'Sin información' }}</p>
        </v-flex>
        <v-flex md3>
          <small>Dia de Vencimiento</small>
          <br />
          <p
            class="caption"
          >{{ dueDate(bill(customer.bill_id).due_day_id).name || 'Sin información' }}</p>
        </v-flex>
        <v-flex md3>
          <small>Asesor</small>
          <br />
          <p class="caption">{{ agent(customer.agent_id).name || 'Sin información' }}</p>
        </v-flex>
      </template>
    </v-layout>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';

export default {
  props: {
    customer: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters({
      portfolio: 'portfolio_type',
      account: 'account_type',
      tranche: 'tranche',
      dueDate: 'due_day',
      agency: 'agency',
      agent: 'agent',
      bill: 'bill',
    }),
    dueName() {
      let name = 'Cuotas';
      if (this.$auth.user().company_id === 8230622) {
        name = 'Polizas';
      }
      return name;
    },
    dueBalance() {
      let name = 'Deuda';
      // if (this.$auth.user().company.id === 3393039) {
      //   name = 'Pago Minimo';
      // }
      return name;
    },
    invoicedName() {
      let name = 'Facturado';
      // if (this.$auth.user().company.id === 3393039) {
      //   name = 'Deuda Vencida';
      // }
      return name;
    },
    accountTypeName() {
      let name = 'Tarjeta';
      if (
        this.$auth.user().company.id === 1539105 
        // || this.$auth.user().company.id === 3393039
      ) {
        name = 'Producto';
      }
      return name;
    },
  },
  methods: {
    formatDate(date, formatDate, format) {
      return moment(date, formatDate).format(format);
    },
    formatNumber(value) {
      return new Intl.NumberFormat('es-VE', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2,
      }).format(value);
    },
  },
};
</script>

<style scoped lang="css">
  .infoTable {
    border: 1px solid #d0c9c9;
    border-width: 0.5px;
    padding: 4px 2em;
  }
</style>


// WEBPACK FOOTER //
// src/components/customer/FinancialInfo.vue